// extracted by mini-css-extract-plugin
export default {"isPaying":"jinKb","button":"ZgZ2u","error":"_7qUmM","cardLabel":"f6pw6","stripeElement":"NOloE","emailInput":"GKb34","emailSuggestion":"_3Xscm"};